import { useState } from 'react'
import { AuthProvider, useAuth } from './lib/AuthContext'
import Login from './pages/Login'
import PortalLayout from './components/PortalLayout'
import AccountabilityMap from './pages/AccountabilityMap'
import ComingSoon from './pages/ComingSoon'
import Scorecard from './pages/Scorecard'
import Priorities from './pages/Priorities'
import Weekly from './pages/Weekly'
import VisionMap from './pages/VisionMap'
import Toolbox from './pages/Toolbox'
import AdminDashboard from './pages/AdminDashboard'
import './styles/global.css'

function Portal({ previewUserId }) {
  const [page, setPage] = useState('accountability-map')

  function renderPage() {
    switch (page) {
      case 'accountability-map': return <AccountabilityMap previewUserId={previewUserId} />
      case 'scorecard': return <Scorecard previewUserId={previewUserId} />
      case 'rocks': return <Priorities previewUserId={previewUserId} />
      case 'level-10': return <Weekly previewUserId={previewUserId} />
      case 'vto': return <VisionMap previewUserId={previewUserId} />
      case 'toolbox': return <Toolbox />
      default: return <AccountabilityMap previewUserId={previewUserId} />
    }
  }

  return (
    <PortalLayout activePage={page} onNavigate={setPage} previewUserId={previewUserId}>
      {renderPage()}
    </PortalLayout>
  )
}

function AppInner() {
  const { user, loading } = useAuth()
  const isAdmin = user?.user_metadata?.role === 'admin'
  const [previewClient, setPreviewClient] = useState(null)

  if (loading) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--hemlock-green-dark)'
    }}>
      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14 }}>Loading…</div>
    </div>
  )

  if (!user) return <Login />

  if (isAdmin && previewClient) return (
    <div>
      {/* Preview banner */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        background: '#B8965A', padding: '8px 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <div style={{ fontSize: 12, fontWeight: 500, color: '#fff' }}>
          👁 Previewing as <strong>{previewClient.companyName}</strong> — read only
        </div>
        <button onClick={() => setPreviewClient(null)} style={{
          fontSize: 12, padding: '4px 14px', borderRadius: 4,
          border: '1px solid rgba(255,255,255,0.4)', background: 'transparent',
          color: '#fff', cursor: 'pointer', fontWeight: 500
        }}>← Exit preview</button>
      </div>
      <div style={{ paddingTop: 36 }}>
        <Portal previewUserId={previewClient.id} />
      </div>
    </div>
  )

  if (isAdmin) return <AdminDashboard onPreviewClient={setPreviewClient} />

  return <Portal />
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  )
}
